import React from 'react'

import { Box } from '@chakra-ui/layout'
import { Button } from '@chakra-ui/button'

import useSound from 'use-sound'

import { useKanban } from '../../../hooks/useKanban'

export function Sound() {
  const { hasNewBookingPending } = useKanban()

  const [play] = useSound(require('../../../assets/sounds/notification.mp3'))

  const playRef = React.useRef<HTMLButtonElement>(null)

  React.useEffect(() => {
    if (hasNewBookingPending) {
      window.bookingInterval = setInterval(() => {
        playRef?.current?.click()
      }, 3000)

      setTimeout(() => {
        clearInterval(window.bookingInterval)
      }, 32500)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playRef.current, hasNewBookingPending])

  return (
    <Box>
      <Button ref={playRef} onClick={() => play()} display="none" />
    </Box>
  )
}
